import { MAX_DECIMAL_PLACES } from './constants';

export const validateAmount = (value: string): boolean => {
  if (!value || value.trim() === '') return true;
  
  const numberRegex = /^\d*\.?\d*$/;
  if (!numberRegex.test(value)) return false;
  
  const decimalParts = value.split('.');
  if (decimalParts.length > 2) return false;
  if (decimalParts[1] && decimalParts[1].length > MAX_DECIMAL_PLACES) return false;
  
  const numValue = parseFloat(value);
  return !isNaN(numValue) && numValue >= 0 && numValue <= 999999999;
};

export const sanitizeAmount = (value: string): string => {
  let sanitized = value.replace(/[^\d.-]/g, '');
  
  const decimalParts = sanitized.split('.');
  if (decimalParts.length > 2) {
    sanitized = decimalParts[0] + '.' + decimalParts.slice(1).join('');
  }
  
  if (decimalParts[1] && decimalParts[1].length > MAX_DECIMAL_PLACES) {
    sanitized = decimalParts[0] + '.' + decimalParts[1].substring(0, MAX_DECIMAL_PLACES);
  }
  
  return sanitized;
};

export const validateCurrencyCode = (code: string): boolean => {
  return /^[A-Z]{3}$/.test(code);
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};